import { styled, useTheme } from "@mui/material";
import { FunctionComponent, ReactNode } from "react";
import { Alignment } from "../../types/theme";
import AccountsGraphic from "./Graphic";

interface Props {
  children: ReactNode;
}

/* TODO: Uncomment this whenever we define the new behaviour */
// const ImageContainer = styled("div")(({ theme }) => ({
//   display: theme.settings.lockScreens.alignment !== "center" ? "none" : "block",
//   position: "absolute",
//   top: "4rem",
//   left: "4rem",
// }));

const Main = styled("div")<{ alignment: Alignment }>(
  ({ alignment, theme }) => ({
    display: "flex",
    minHeight: "100%",
    [theme.breakpoints.up("md")]: {
      flexDirection: alignment === "left" ? "row-reverse" : "row",
      justifyContent: alignment === "center" ? "center" : "normal",
    },
  }),
);

const LockScreen: FunctionComponent<Props> = ({ children }: Props) => {
  const theme = useTheme();
  return (
    <Main alignment={theme.settings.lockScreens.alignment}>
      <AccountsGraphic />
      {children}
    </Main>
  );
};

export default LockScreen;
